/**
 * Created by luka on 23.02.2018.
 */
import {
    BET_MODE, AD,
    DAYS_FETCH_DATA_SUCCESS, DAYS_LOADING, EXTEND_OR_PAYOUT, INITIAL_ORDER, INVITES, LINK, LOADING_DAYS_FAILED,
    MONTHLY_TOTAL, NEXT_PAYOUT, OFFER_PAYOUT, OPEN_DAYS, PERIOD, PERIOD_BEGIN, POST_ID, RETRY, SHOW_INVITE_FRIENDS,
    SUCCESSFUL_MONTHS, USER_ON_TRACK, NEW_VERSION
} from "../actions/types";


export function loadingDaysFailed(state = false, action) {
    switch (action.type) {
        case LOADING_DAYS_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function daysLoading(state = false, action) {
    switch (action.type) {
        case DAYS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function days(state = [], action) {
    switch (action.type) {
        case DAYS_FETCH_DATA_SUCCESS:
            return action.days;
        default:
            return state;
    }
}

export function invites(state = [], action) {
    switch (action.type) {
        case INVITES:
            return action.invites;
        default:
            return state;
    }
}

export function monthlyTotal(state = 0, action) {
    switch (action.type) {
        case MONTHLY_TOTAL:
            return action.monthlyTotal;
        default:
            return state;
    }
}

export function openDays(state = 30, action) {
    switch (action.type) {
        case OPEN_DAYS:
            return action.openDays;
        default:
            return state;
    }
}


export function initialOrder(state = 0, action) {
    switch (action.type) {
        case INITIAL_ORDER:
            return action.initialOrder;
        default:
            return state;
    }
}

export function betMode(state = 1, action) {
    switch (action.type) {
        case BET_MODE:
            return action.betMode;
        default:
            return state;
    }
}

//legacy can be deleted
export function postId(state = null, action) {
    switch (action.type) {
        case POST_ID:
            return action.postId;
        default:
            return state;
    }
}
// ende lagacy

export function link(state = null, action) {
    switch (action.type) {
        case LINK:
            return action.link;
        default:
            return state;
    }
}

export function ad(state = {}, action) {
    switch (action.type) {
        case AD:
            return action.ad;
        default:
            return state;
    }
}

export function offerPayout(state = false, action) {
    switch (action.type) {
        case OFFER_PAYOUT:
            return action.offerPayout;
        default:
            return state;
    }
}

export function retry(state = false, action) {
    switch (action.type) {
        case RETRY:
            return action.retry;
        default:
            return state;
    }
}

export function nextPayout(state = null, action) {
    switch (action.type) {
        case NEXT_PAYOUT:
            return action.nextPayout;
        default:
            return state;
    }
}

export function periodBegin(state = null, action) {
    switch (action.type) {
        case PERIOD_BEGIN:
            return action.periodBegin;
        default:
            return state;
    }
}

export function successfulMonths(state = null, action) {
    switch (action.type) {
        case SUCCESSFUL_MONTHS:
            return action.successfulMonths;
        default:
            return state;
    }
}

export function period(state = 0, action) {
    switch (action.type) {
        case PERIOD:
            return action.period;
        default:
            return state;
    }
}

export function userOnTrack(state = true, action) {
    switch (action.type) {
        case USER_ON_TRACK:
            return action.userOnTrack;
        default:
            return state;
    }
}

export function newVersion(state = false, action) {
    switch (action.type) {
        case NEW_VERSION:
            return action.newVersion;
        default:
            return state;
    }
}

export function showInviteFriends(state = false, action) {
    switch (action.type) {
        case SHOW_INVITE_FRIENDS:
            return action.showInviteFriends;
        default:
            return state;
    }
}

export function extendOrPayout(state = false, action) {
    switch (action.type) {
        case EXTEND_OR_PAYOUT:
            return action.isAllowed;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/overview/OverviewReducer.js